import { CheckIcon, PlusIcon, Pencil } from 'lucide-react';
import { MouseEventHandler, useState } from 'react';
import { Badge } from '../../components/ui/badge';

interface SelectorProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  variant: 'default' | 'active' | 'selected';
  text: string;
  selectionCount?: number;
}

const Selector = ({ onClick, variant = 'default', text, selectionCount }: SelectorProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const defaultStyle =
    'inline-flex items-center justify-center px-3 py-1 border rounded-full align-top h-11';

  switch (variant) {
    case 'default':
      return (
        <button
          onClick={onClick}
          className={`${defaultStyle} border-ring text-card-foreground hover:bg-primary/15 hover:border-primary`}
        >
          <PlusIcon size="16" className="mr-1" />
          {text}
        </button>
      );
    case 'active':
      return (
        <button
          onClick={onClick}
          className={`${defaultStyle} border-ring text-card-foreground hover:bg-primary/15 hover:border-primary`}
        >
          {text}
        </button>
      );
    case 'selected':
      return (
        <button
          onClick={onClick}
          className={`${defaultStyle} bg-primary border-primary text-primary-foreground transition-colors font`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {!isHovered && <CheckIcon size="24" className="mr-2" />}
          {isHovered && <Pencil size="24" className="mr-2 scale-80" />}
          {text}
          {selectionCount && selectionCount > 0 && (
            <Badge variant="inverted" className="ml-2 h-5 min-w-5 px-1">
              {selectionCount}
            </Badge>
          )}
        </button>
      );
    default:
      return null;
  }
};

export default Selector;
